import type { Brick } from "../objects/Brick.js";
import type { Projectile } from "../objects/Projectile.js";
import type Phaser from "phaser";
import { getGameviewContentOffset } from "../ui/sceneLayout.js";

interface ChildrenGroup {
  getChildren(): unknown[];
}

type BrickMask = Parameters<Brick["applyContentMask"]>[0];

interface GameviewMaskLike {
  readonly bounds?: { readonly y: number; readonly height: number };
  readonly mask: BrickMask;
}

export function offsetActiveProjectiles(projectiles: ChildrenGroup, delta: number): void {
  if (delta === 0) return;
  for (const obj of projectiles.getChildren()) {
    const projectile = obj as Projectile;
    if (projectile.active) projectile.y -= delta;
  }
}

export function reconcileBricksForGameviewOffset(input: {
  readonly scene: Phaser.Scene;
  readonly bricks: ChildrenGroup;
  readonly gameviewMask?: GameviewMaskLike;
}): number {
  const offset = getGameviewContentOffset(input.scene);
  for (const obj of input.bricks.getChildren()) {
    const brick = obj as Brick;
    if (!brick.active) continue;
    brick.applyContentOffsetAbsolute(offset);
    if (input.gameviewMask) brick.applyContentMask(input.gameviewMask.mask);
    else brick.clearContentMask();
  }
  return offset;
}
